<script setup lang="ts">
import AuthModals from '~/components/modals/authModals/AuthModals.vue'
import NavBar from '~/components/Navbar.vue'
import Footer from '~/components/Footer.vue'
import {useLoading} from "~/composables/useLoading";
import DevTag from "~/components/producer/DevTag.vue";

const mainLoading = ref(true)
const {loading} = useLoading()

onMounted(() => {
  mainLoading.value = true
  setTimeout(() => {
    let n: HTMLElement | null = document.querySelector(".btn-scroll-top");
    let a = 600;

    if (n) {
      window.addEventListener("scroll", (e) => {
        if (window.scrollY > a) {
          n?.classList.add("show");
        } else {
          n?.classList.remove("show");
        }
      });
      n?.addEventListener("click", () => {
        window.scrollTo({top: 0, behavior: "smooth"});
      });
    }
  }, 0);
  setTimeout(() => mainLoading.value = false, 100)
})
</script>
<template>
  <!-- Page loading spinner-->
  <div class="page-loading active" v-if="loading || mainLoading">
    <div class="page-loading-inner">
      <div class="page-spinner"></div>
      <span>Carregando...</span>
    </div>
  </div>
  <AuthModals/>
  <NavBar/>
  <main class="page-wrapper mt-5 pt-5">
    <DevTag/>
    <slot/>
  </main>
  <Footer/>
  <a class="btn-scroll-top" href="#top">
    <span class="btn-scroll-top-tooltip text-muted fs-sm me-2">Top</span>
    <i class="btn-scroll-top-icon fi-chevron-up"></i>
  </a>
</template>
<style scoped>
.page-wrapper {
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 80vh;
  padding-top: 2rem !important;
}
</style>
